<mat-card appearance="outlined">
  <mat-card-content>
    <mat-list>
      <mat-list-item *ngFor="let email of emails; let idx = index">
        <div matListItemTitle>
          <span *ngIf="email.type === 'secondary'" i18n>Secondary email:</span>
          <span *ngIf="email.type === 'primary'" i18n>Primary email:</span>
          &nbsp;<span>{{ email.email }}</span>
        </div>
        <div matListItemMeta>
          <button mat-icon-button color="primary" (click)="onClick(idx)">
              <mat-icon>edit</mat-icon>
           </button>
          <button mat-icon-button (click)="onRemove(idx)">
              <mat-icon>delete</mat-icon>
          </button>
        </div>
      </mat-list-item>
    </mat-list>
  </mat-card-content>
</mat-card>
